import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
    MIXPANEL_PAGE_NAMES,
} from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';
import store from '../../store';

interface Payload {
    brandName: string;
    slogan: string;
}

export const reportListingTextFieldChange = ({ brandName, slogan }: Payload) => {
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_ACTION, {
        ...getDataFromStores(
            store.user,
            store.brief,
            store.briefSource,
            store.pagePath,
            store.statistics,
            store.referrer,
            store.fromBoost
        ),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.BUYER,
        [MIXPANEL_EVENT_PROPERTIES.BRAND_NAME]: brandName,
        [MIXPANEL_EVENT_PROPERTIES.SLOGAN]: slogan,
        [MIXPANEL_EVENT_PROPERTIES.ACTION]: 'Text Fields Changed',
    });
};
